import React from 'react';
import { Box, Typography } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
  icons: {
    height: 30,
  },
  linkBox: {
    margin: '0 10px',
  },
  linkText: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#228cb9',
  },
});

const LinkBox = ({classes, icon, text}) => (
  <Box
    display="flex"
    flexDirection="column"
    className={classes.linkBox}>
    <img src={icon} className={classes.icons} alt="Kurse" />
    <Typography variant="button" component="p" className={classes.linkText}>
      {text}
    </Typography>
  </Box>
);

export default withStyles(styles)(LinkBox);
